import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function Section5ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {

        headingSection2: stringsTranslate(appWords.how_couponing_works),
        playImg2: "/assets/images/ForCompanies/image 3.webp",
    }

    return (
        <section className="section " id='couponing'>
            <div className="container-fluid ">
                {/*Section 5*/}

                <div className="row section5-for-companies justify-content-center align-items-center px-0 px-lg-5 px-md-5 mt-0 mt-lg-5 mt-md-5 pb-4 pb-lg-5 pb-md-5">
                    <div className="col-lg-12 col-md-12 text-center mt-5 ">
                        <div className={'w-100 flex-wrap d-flex text-center justify-content-center'}>
                            <h5 onClick={() => goToYouTube()}
                                className={"cursor-pointer text-knaek-title img-text-section5-for-companies "}>
                                {initStrings.headingSection2}
                            </h5>
                        </div>
                        <img src={initStrings.playImg2}
                             className={"img-section5-for-companies cursor-pointer mt-2 mt-lg-4 mt-md-4"} alt={""}
                             onClick={() => goToYouTube()}/>

                    </div>
                </div>


            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=NngjpBjS3ME')

        } else {
            window.open('https://www.youtube.com/watch?v=IcuCt12_VOY')

        }

    }

}
